export var getLineItemIds = function (lineItems) {
    return lineItems
        .filter(function (item) { return !item.isAssembly; })
        .map(function (item) { return Number(item.lineId); })
        .filter(function (lineId) { return !Number.isNaN(lineId); });
};
